export const planBgClass = (data: string) => {
  switch (data) {
    case '100': {
      return 'bg-plan-100';
    }
    case '30': {
      return 'bg-plan-30';
    }
    case '8': {
      return 'bg-plan-8';
    }
    case '5': {
      return 'bg-plan-5';
    }
    case '3': {
      return 'bg-plan-3';
    }
    case 'family': {
      return 'bg-plan-family';
    }
    case 'add-phone': {
      return 'bg-surface-modal';
    }
    default: {
      return 'bg-surface-tertiary';
    }
  }
};
